module.exports = __webpack_public_path__ + "img/10_8.04f4ef46.png";